import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import recruit from "../views/recruit.vue";
import join from "../views/join.vue";
import enter from "../views/enter.vue";
import cooperation from "../views/cooperation.vue";
import system from "../views/system.vue";
import schoolProblemFeedback from "../views/schoolProblemFeedback.vue";
import schoolProblemFeedForm from '@/views/schoolProblemFeedForm.vue';
import Home from "../views/Home.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/recruit",
    name: "recruit",
    component: recruit,
  },
  {
    path: "/join",
    name: "join",
    component: join,
  },
  {
    path: "/enter",
    name: "enter",
    component: enter,
  },
  {
    path: "/cooperation",
    name: "cooperation",
    component: cooperation,
  },
  {
    path: "/system",
    name: "system",
    component: system,
  },
  {
    path: "/schoolProblemFeedback",
    name: "schoolProblemFeedback",
    component: schoolProblemFeedback,
  },
  {
    path: "/schoolProblemFeedback/form",
    name: "schoolProblemFeedForm",
    component: schoolProblemFeedForm,
  },
  
  // {
  //   path: "/punishResult", // 处罚结果
  //   name: "punishResult",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "punishResult" */ "../views/punishResult.vue"),
  // },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory("/"),
  routes,
});

export default router;
